export const EMPTY_ANNOUNCEMENT = {
  enabled: false,
  variant: "warning",
  title: "",
  message: "",
  linkLabel: "",
  linkUrl: "",
  openInNewTab: true,
  displayFrom: "",
  displayTo: "",
};

export const VARIANT_LABELS = {
  info: "Neutralny komunikat",
  warning: "Ważna informacja",
  critical: "Pilny komunikat",
  success: "Pozytywna informacja",
};

const normalizeDateTime = (value) => (value ? value.slice(0, 16) : "");

export const normalizeAnnouncement = (settings) => ({
  ...EMPTY_ANNOUNCEMENT,
  ...(settings || {}),
  displayFrom: normalizeDateTime(settings?.displayFrom),
  displayTo: normalizeDateTime(settings?.displayTo),
});

export const hasAnnouncementContent = (announcement) =>
  Boolean(
    announcement.title?.trim() ||
      announcement.message?.trim() ||
      (announcement.linkLabel?.trim() && announcement.linkUrl?.trim()),
  );

export const getAnnouncementStatus = (announcement) => {
  const now = new Date();
  const displayFrom = announcement.displayFrom
    ? new Date(announcement.displayFrom)
    : null;
  const displayTo = announcement.displayTo
    ? new Date(announcement.displayTo)
    : null;

  if (!announcement.enabled) return "Wyłączony";
  if (!hasAnnouncementContent(announcement)) return "Brak treści";
  if (displayFrom && now < displayFrom) return "Zaplanowany";
  if (displayTo && now > displayTo) return "Zakończony";
  return "Aktywny";
};
